<template>
  <v-alert
    class="w-100 mt-4 text-body-small"
    data-test-id="deep-sign-alert"
    type="warning"
    variant="tonal"
  >
    <slot :is-user-owner="isUserOwner" name="text"></slot>
    <div v-if="!$slots.text">
      <slot>
        <div
          v-html="
            isUserOwner
              ? ownerText
              : i18n.t(
                  'errors.api.accounting.has_no_payment_method_member_admin'
                )
          "
        ></div>
      </slot>
    </div>
  </v-alert>
</template>
<script setup lang="ts">
import { computed, type PropType } from 'vue';
import type { Company } from '@/types/deepadmin/Company';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  selectedOrganisation: {
    type: Object as PropType<Company>,
    default: undefined
  }
});
const i18n = useI18n();

const isUserOwner = computed(() =>
  props.selectedOrganisation?.roles.includes('MANAGE_COMPANY')
);

const ownerText = computed(() => {
  const text = i18n.t('errors.api.accounting.has_no_payment_method_owner');
  const link = `${import.meta.env.VITE_DEEPADMIN_BASE_URL}organizations/${props.selectedOrganisation?.group_id}/billing/payment`;
  // Default case
  return text.replace(
    '_link_',
    `<a class="text-primary" href="${link}">${i18n.t('text.manage_account')}</a>`
  );
});
</script>
